<template>
    <page-view title="项目统计">
        <a-card>
        <a-tabs type="card">
            <a-tab-pane key="1" tab="Tab 1">
               <ProjectStatisticsFwf></ProjectStatisticsFwf>
            </a-tab-pane>
            <a-tab-pane key="2" tab="Tab 2">
                <ProjectStatisticsXmsl></ProjectStatisticsXmsl>
            </a-tab-pane>
        </a-tabs>
        </a-card>
    </page-view>
</template>

<script>
  import { PageView } from '@/layouts'
  import ProjectStatisticsFwf from './ProjectStatisticsFwf'
  import ProjectStatisticsXmsl from './ProjectStatisticsXmsl'

  export default {
    name: 'ProjectStatisticsIndex',
    components: {
      PageView,
      ProjectStatisticsFwf,
      ProjectStatisticsXmsl
    },
    data () {
      return {}
    },
    created () {

    },
    methods: {}
  }
</script>

<style scoped>

</style>
